import React from 'react';
import { Col } from 'antd';
import { SymptomLocationFormItem } from '@/components/views/Resolution886/components/Form';

export function SymptomLocation(): JSX.Element {
	return (
		<Col xs={24}>
			<SymptomLocationFormItem fieldName="symptom_location" required={false} />
		</Col>
	);
}
